import SearchSectionFilterChip from './FilterChip';

export default SearchSectionFilterChip;
